import React from 'react'

import Image from 'components/ui/Image/Image'

import placeholder from './images/placeholder.jpg'


const PlaceholderImage = ({ src, ...rest }) => (
  <Image
    src={placeholder}
    {...rest}
  />
)


export default PlaceholderImage
